export default __webpack_public_path__ + "static/crp-gradient-3321f7b9f38f0605dc0c8c775185c1f2.svg";